import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import StemdoerDetail from './StemdoerDetail.vue';
import { Stemdoer } from '@/shared/model/stemdoer.model';
import { IRate } from '@/shared/model/rate.model';


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalStemdoerDetail',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  onClose: {
    type: Function,
    required: true
  },
  stemdoer: {
    type: Object as () => Stemdoer,
    required: true
  },
  rate: {
    type: Number
  },
  rates: {
    type: Array as () => IRate[]
  },
  company: {
    type: Object,
    required: false
  },
  onAddToCart: {
    type: Function,
    required: false
  }
},
  setup(__props) {

const props = __props;


const isDialogOpen = ref(props.isOpen);

watch(
  () => props.isOpen,
  value => {
    isDialogOpen.value = value;
  }
);

const closeDialog = () => {
  props.onClose();
};

const handleAddToCart = (stemdoerId: string) => {
  if (props.onAddToCart) {
    props.onAddToCart(stemdoerId);
    props.onClose();
  }
};

const resetOverflow = () => {
  document.documentElement.style.overflow = 'auto';
};

return { __sfc: true,props, isDialogOpen, closeDialog, handleAddToCart, resetOverflow, StemdoerDetail }
}

})